import { axios } from "../../utils";

export async function patchUser(data, accessToken) {
  await axios.patch(
    "/user/profile",
    {
      nickname: data.nickname,
      phone: data.phone,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
}
